import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FilterListOutlined, GridViewOutlined, ViewList } from '@mui/icons-material';
import classnames from 'classnames';

import { DateRange } from 'components/containers';
import { Button } from 'components/ui';

import * as Styled from './Header.styles';

export const Header = ({ filters, changeFilters, changeView, view }) => {
  const [areFiltersVisible, setAreFiltersVisible] = useState(false);

  return (
    <Styled.Wrapper>
      <Styled.Row>
        <Styled.Title>
          Faktury kosztowe
          <Button variant="text" onClick={() => setAreFiltersVisible(!areFiltersVisible)} className="filtersButton">
            <FilterListOutlined /> Filtry
          </Button>
        </Styled.Title>

        <Styled.ViewType>
          <ViewList onClick={() => changeView('table')} className={classnames({ current: view === 'table' })} />
          <GridViewOutlined onClick={() => changeView('grid')} className={classnames({ current: view === 'grid' })} />
        </Styled.ViewType>
      </Styled.Row>

      {areFiltersVisible && (
        <Styled.Row>
          <DateRange
            onChange={(dates) => changeFilters({ ...filters, ...dates })}
            toDate={filters.toDate}
            fromDate={filters.fromDate}
          />
        </Styled.Row>
      )}
    </Styled.Wrapper>
  );
};

Header.propTypes = {
  view: PropTypes.string.isRequired,
  filters: PropTypes.object.isRequired,
  changeFilters: PropTypes.func.isRequired,
  changeView: PropTypes.func.isRequired,
};
